import lodash from 'lodash';
import { getFieldsOfDeliveryAddress } from 'components/forms/DeliveryAddress';
import { getHomeAddressFields } from 'components/forms/HomeAddress';
import { CustomerInfoKeyType } from 'types/customer';
import { TaxformCustomerInfoType } from './type';

export const proveContentList = [
    'I am the individual that is the beneficial owner (or am authorized to sign for the individual that is the beneficial owner) of all the income to which this form relates or am using this form to document myself for chapter 4 purposes,',
    'The person named on line 1 of this form is not a U.S. person,',
    "The income to which this form relates is:\n(a)not effectively connected with the conduct of a trade or business in the United States,\n(b)effectively connected but is not subject to tax under an income tax treaty, or\n(c)the partner's share of a partnership's effectively connected income,",
    'The person named on line 1 of this form is a resident of the treaty country listed on the form (if any) within the meaning of the income tax treaty between the United States and that country, and',
    'For broker transactions or barter exchanges, the beneficial owner is an exempt foreign person as defined in the instructions.',
    'Furthermore, I authorize this form to be provided to any withholding agent that has control, receipt, or custody of the income of which I am the beneficial owner or any withholding agent that can disburse or make payments of the income of which I am the beneficial owner.',
    'I agree that I will submit a new form within 30 days if any certification made on this form becomes incorrect.'
];

/**
 * @description 非SSN开户时获取在w8展示的邮寄地址。默认情况下邮寄地址与居住地址一致，则使用居住地址对应的字段填充
 */
export function getDeliveryAddressDetail(addressData: TaxformCustomerInfoType, useHomeAddress: boolean) {
    // 四个中国开户流程不存在“邮寄地址与居住地址不一样”字段，但需要获取相应字段，所以这里same_delivery_and_residence默认等于0
    const { delivery_address_type, same_delivery_and_residence = '0', home_address_type } = addressData;

    let fields: CustomerInfoKeyType[] = [];

    if (useHomeAddress) {
        fields = getHomeAddressFields(home_address_type, false).filter(
            item => !['home_postal', 'same_delivery_and_residence', 'has_delivery_address'].includes(item)
        );
    } else {
        fields = getFieldsOfDeliveryAddress(delivery_address_type, same_delivery_and_residence, false).filter(
            item => !['delivery_postal', 'delivery_country'].includes(item)
        );
    }

    return Object.values(lodash.pick(addressData, fields)).filter(Boolean).join(' ');
}
